import * as React from "react";

export type PluralData = {
  singular: string;
  plural: string;
};

type Props = {
  count?: number;
} & (PluralData | { data: PluralData });

const PluralText = ({ count, ...props }: Props): React.ReactElement => {
  if (count == null) {
    return <></>;
  }

  if ("data" in props) {
    return <>{pluralize(count, props.data.singular, props.data.plural)}</>;
  } else {
    return <>{pluralize(count, props.singular, props.plural)}</>;
  }
};

export function pluralize(
  count: number,
  singular: string,
  plural: string
): string {
  return count === 1 ? singular : plural;
}

export function pluralizeData(count: number, data: PluralData): string {
  return pluralize(count, data.singular, data.plural);
}

export default PluralText;
